export default __webpack_public_path__ + "static/fall12-dfcd2b4e490612b82b277c7738f1d914.webp";